import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { useCallback, useEffect, useRef } from 'react';
import {
  useQuizMetaContext,
  useQuizResults,
  useFollowerQuizGameState,
} from '@mentimeter/quiz';
import type { QuizPlayersScoreData } from '@mentimeter/core-hooks';
import { GameStatesSwitcher } from './GameStateSwitcher';

export const FollowerPresentationDataHandler = ({
  activeSession,
}: {
  activeSession: number;
}) => {
  const { useQuestion } = usePresentationContext();
  const {
    image,
    time_based_scoring,
    question,
    title_meta,
    question_description,
    question_styled,
    layout,
    choices,
  } = useQuestion();
  const { totalCount, currentIndex, follower } = useQuizMetaContext();
  const { data = [], isPreviewResults } =
    useQuizResults<QuizPlayersScoreData>();
  const {
    gameState,
    timeOffset = 0,
    connectedPlayers,
    respondents,
    joinAsFollower,
    connectedWithDelay,
  } = useFollowerQuizGameState();

  const prevActiveSession = useRef(activeSession);
  const createdRef = useRef(false);
  useEffect(() => {
    const sessionChanged = prevActiveSession.current !== activeSession;
    if ((!gameState && !createdRef.current) || sessionChanged) {
      joinAsFollower();
    }
  }, [joinAsFollower, follower, activeSession, gameState]);

  const onReload = useCallback(() => {
    window.location.reload();
  }, []);

  const correctAnswer = (choices[0] || {}).label;

  return (
    <GameStatesSwitcher
      isReadonly={true}
      onMarkAnswer={undefined}
      everyoneHasVoted={false}
      correctAnswer={correctAnswer}
      imageUrl={image?.presets?.original?.url ?? image?.presets?.large?.url}
      timeBasedScoring={time_based_scoring}
      question={question}
      questionStyled={question_styled}
      meta={title_meta}
      description={question_description}
      layout={layout}
      results={data}
      isPreviewResults={Boolean(isPreviewResults)}
      gameState={gameState}
      timeOffset={timeOffset}
      connectedPlayers={connectedPlayers}
      respondents={respondents}
      onReload={onReload}
      connectedWithDelay={connectedWithDelay}
      totalQuizQuestions={totalCount}
      currentQuizQuestionIndex={currentIndex}
    />
  );
};
